module.exports = __webpack_public_path__ + "img/trivia-822.28724ccb.jpeg";